import DOMPurify from 'dompurify';

/**
 * Normalizes arbitrary HTML fragments by stripping unsafe markup.
 * Falls back to an empty string when input is falsy.
 */
export const sanitizeHtml = (value) => {
  if (!value) {
    return '';
  }

  return DOMPurify.sanitize(value);
};
